<template>
  <div>
    <!-- Description block -->
    <div class="card" qid="basic-info-section" id="update_description">
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="content-view-body">
          <div class="mb-2">
            <h5 class="h5" v-if="!showOnTask">
              <span class="float-right btn btn-sm btn-edit"
                    @click="showDescriptionInputFunction"
                    qid="system-edit-description"
                    v-if="!showDescriptionInput && isGranted([permissions.SYSTEM_EDIT, permissions.SYSTEM_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
              >
                <font-awesome-icon icon="pen"/>
              </span>
              <span class="float-right" v-if="showDescriptionInput">
                <div class="text-right">
                  <b-button class="btn-sm inline-edit-button"
                            variant="secondary"
                            @click="cancelDescriptionForm"
                            qid="edit-description-cancel-button"
                  >
                    {{ $t('systems.create.cancel') }}
                  </b-button>
                  <b-button class="ml-3 btn-sm inline-edit-button"
                            variant="success"
                            @click="formDescriptionSubmit"
                            qid="edit-description-submit-button"
                  >
                    {{ $t('systems.create.submit') }}
                  </b-button>
                </div>
              </span>
              {{ $t('systems.create.description_label') }}
            </h5>
            <h5 class="h5" v-if="showOnTask">
              <span class="float-right btn btn-sm btn-edit"
                    @click="showDescriptionInputFunction"
                    qid="system-edit-description"
                    v-if="!showDescriptionInput && isGranted([permissions.SYSTEM_EDIT, permissions.SYSTEM_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
              >
                <font-awesome-icon icon="pen"/>
              </span>
              <span class="float-right" v-if="showDescriptionInput">
                <div class="text-right">
                  <b-button class="btn-sm inline-edit-button"
                            variant="secondary"
                            @click="cancelDescriptionForm"
                            qid="edit-description-cancel-button"
                  >
                    {{ $t('systems.create.cancel') }}
                  </b-button>
                  <b-button class="ml-3 btn-sm inline-edit-button"
                            variant="success"
                            @click="formDescriptionSubmit"
                            qid="edit-description-submit-button"
                  >
                    {{ $t('systems.create.submit') }}
                  </b-button>
                </div>
              </span>
              &nbsp;
            </h5>

            <span v-if="!showOnTask">
              <span class="cursor-pointer task-label-open mr-2 ml-2 mr-2"
                    v-if="getTask('update_description')"
              >
                <UpdateSingleTaskModal
                    :task="myTasks[0]"
                    @reloadContent="reloadContent"
                    :editIcon="true"
                ></UpdateSingleTaskModal>
              </span>
              <span v-if="getGuide('update_description')">
                <GuideButton :guide="getGuide('update_description')"></GuideButton>
              </span>
            </span>
          </div>

          <div v-if="showDescriptionInput">
            <b-form-textarea
              qid="edit-tp-form-description"
              v-model="systemEditDescription"
              rows="6"
              :placeholder="$t('maintenance.third_parties.create.description_placeholder')"
            ></b-form-textarea>
          </div>
          <div v-if="!showDescriptionInput" class="section-container">
            <div v-if="system.description && system.description.length > descriptionLength">
              <p v-if="showFullDescription" class="text-formatted">{{ system.description }}</p>
              <p v-if="!showFullDescription" class="text-formatted">{{ system.description | truncate(descriptionLength) }}</p>
              <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
                <span class="cursor-pointer" v-if="!showFullDescription">
                  <span class="mr-2">
                    {{ $t('system.view_more') }}
                  </span>
                  <font-awesome-icon icon="chevron-down"/>
                </span>
                <span class="cursor-pointer" v-if="showFullDescription">
                  <span class="mr-2">
                    {{ $t('system.view_less') }}
                  </span>
                  <font-awesome-icon icon="chevron-up"/>
                </span>
              </div>
            </div>
            <p v-if="system.description && system.description.length <= descriptionLength"
               class="text-formatted"
            >{{ system.description }}</p>
            <p v-if="!system.description" class="text-muted">
              {{ $t('system.missing_input') }}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'DescriptionBlock',
    data: function() {
      return {
        system: {},
        descriptionLength: config.descriptionLength,
        showFullDescription: false,
        showDescriptionInput: false,
        showPurposeInput: false,
        systemEditDescription: '',

        error: '',
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {},
      submitForm: {}
    },
    components: {
      Avatar,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (value) {
        this.system = value

        if (this.showOnTask && !this.system.description) {
          this.systemEditDescription = ''
          this.showDescriptionInput = true;
        }

        if (this.showOnTask && this.system.description) {
          this.showDescriptionInput = false;
        }

        this.loadTasks('update_description');
      },
      submitForm: function (value) {
        if (value) {
          if (this.showDescriptionInput) {
            this.formDescriptionSubmit()
          }
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_description')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent();
        this.loadTasks('update_description');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'systems.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showDescriptionInputFunction() {
        this.showDescriptionInput = true;
        this.systemEditDescription = this.system.description;
      },
      formDescriptionSubmit() {
        let self = this;
        piincHttp.put('systems/' + this.system.slug, {
          description: this.systemEditDescription
        }).then(function(response) {
          self.system = response.data;
          self.showDescriptionInput = false;
          self.loadTasks('update_description');
          self.$store.commit('storeUpdateContent', self.system);
          self.$toastr('success', self.$t('systems.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelDescriptionForm() {
        this.showDescriptionInput = false;
        this.systemEditDescription = this.system.description;
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
        }, function() {});
      }
    },
    created () {
      this.system = this.object;

      if (this.showOnTask && !this.system.description) {
        this.showDescriptionInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      if (this.system && this.system.id) {
        this.loadTasks('update_description');
      }

      this.loadGuides('update_description');

    }
  }
</script>
